import React from 'react';
import PropTypes from 'prop-types';

export const SvgUser = ({ width, height }) => (
  <svg width={width || '14px'} height={height || '13px'} viewBox="0 0 14 13" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-71.000000, -292.000000)" stroke="#000000" strokeWidth="2">
        <g transform="translate(66.000000, 287.000000)">
          <path d="M17.3333333,18 L17.3333333,16.6666667 C17.3333333,15.1939073 16.139426,14 14.6666667,14 L9.33333333,14 C7.860574,14 6.66666667,15.1939073 6.66666667,16.6666667 L6.66666667,18" />
          <circle cx="12" cy="8.66666667" r="2.66666667" />
        </g>
      </g>
    </g>
  </svg>
);

SvgUser.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
